require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-unique-slug-news-articles-using-laravels-unique-valitation.json") })
        }
      }, "path---post-unique-slug-news-articles-using-laravels-unique-valitation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-unique-slug-news-articles-using-laravels-unique-valitation!./.cache/json/post-unique-slug-news-articles-using-laravels-unique-valitation.json
// module id = 361
// module chunks = 231608221292675